import { isPreviewBootstrapLocation } from '#pplx/frontend/apps/ask/asset-viewers/iframe-security/previewUrl.js';
import { isLocalhost, isPreview, isStaging, isTesting, } from '#pplx/frontend/platform-components/env.js';
const PRODUCTION_PUBLISHED_APP_BASE_DOMAIN = 'pplx.app';
const TESTING_PUBLISHED_APP_BASE_DOMAIN = 'testing.pplx.app';
const STAGING_PUBLISHED_APP_BASE_DOMAIN = 'staging.pplx.app';
const LOCAL_PUBLISHED_APP_BASE_ORIGIN = import.meta.env.VITE_ASI_CGI_PUBLIC_URL || 'http://localhost:8100';
const LOCAL_PUBLISHED_APP_BASE_DOMAIN = 'localhost';
const INTERNAL_SITE_PROXY_HOSTNAMES = new Set([
    'sites.pplx.app',
    'sites-staging.pplx.app',
    'sites-staging.staging.pplx.app',
    'sites-testing.pplx.app',
    'sites-testing.testing.pplx.app',
]);
const RESERVED_PUBLISHED_APP_SUBDOMAINS = new Set([
    'blog',
    'docs',
    'sites',
    'sites-staging',
    'sites-testing',
    'www',
]);
const PUBLISHED_APP_SUBDOMAIN_PATTERN = /^[a-z0-9](?:[a-z0-9-]{1,61}[a-z0-9])?$/;
function getCurrentHostname() {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return window.location.hostname;
}
function getLocalPublishedAppOrigin() {
    return new URL(LOCAL_PUBLISHED_APP_BASE_ORIGIN);
}
export function getPublishedAppBaseDomain(hostname = getCurrentHostname()) {
    if (!hostname) {
        return PRODUCTION_PUBLISHED_APP_BASE_DOMAIN;
    }
    if (isStaging(hostname)) {
        return STAGING_PUBLISHED_APP_BASE_DOMAIN;
    }
    if (isLocalhost(hostname)) {
        return getLocalPublishedAppOrigin().host;
    }
    if (isTesting(hostname) || isPreview(hostname)) {
        return TESTING_PUBLISHED_APP_BASE_DOMAIN;
    }
    return PRODUCTION_PUBLISHED_APP_BASE_DOMAIN;
}
/** Branded TLD shown in publish UI; always production regardless of environment. */
export function getPublishedAppDisplayDomain() {
    return PRODUCTION_PUBLISHED_APP_BASE_DOMAIN;
}
export function getPublishedAppUrl(appSlug, hostname = getCurrentHostname()) {
    if (hostname && isLocalhost(hostname)) {
        const origin = getLocalPublishedAppOrigin();
        return `${origin.protocol}//${appSlug}.${origin.host}`;
    }
    return `https://${appSlug}.${getPublishedAppBaseDomain(hostname)}`;
}
function hasSingleSubdomain(hostname, baseDomain) {
    const suffix = `.${baseDomain}`;
    if (!hostname.endsWith(suffix)) {
        return false;
    }
    const subdomain = hostname.slice(0, -suffix.length);
    return Boolean(subdomain) && !subdomain.includes('.');
}
function getPublishedAppSubdomain(hostname, baseDomain) {
    if (!hasSingleSubdomain(hostname, baseDomain)) {
        return null;
    }
    return hostname.slice(0, -(baseDomain.length + 1));
}
export function isPublishedAppUrl(url) {
    if (!url) {
        return false;
    }
    let hostname;
    let protocol;
    try {
        const parsed = new URL(url);
        protocol = parsed.protocol;
        hostname = parsed.hostname.toLowerCase();
        if (isPreviewBootstrapLocation(parsed))
            return false;
    }
    catch {
        return false;
    }
    const isLocalPublishedApp = hostname.endsWith(`.${LOCAL_PUBLISHED_APP_BASE_DOMAIN}`);
    if (protocol !== 'https:' && !(protocol === 'http:' && isLocalPublishedApp)) {
        return false;
    }
    const baseDomains = [
        PRODUCTION_PUBLISHED_APP_BASE_DOMAIN,
        TESTING_PUBLISHED_APP_BASE_DOMAIN,
        STAGING_PUBLISHED_APP_BASE_DOMAIN,
        LOCAL_PUBLISHED_APP_BASE_DOMAIN,
    ];
    return baseDomains.some((baseDomain) => {
        const subdomain = getPublishedAppSubdomain(hostname, baseDomain);
        if (!subdomain) {
            return false;
        }
        return (PUBLISHED_APP_SUBDOMAIN_PATTERN.test(subdomain) &&
            !subdomain.startsWith('xn--') &&
            !RESERVED_PUBLISHED_APP_SUBDOMAINS.has(subdomain) &&
            !INTERNAL_SITE_PROXY_HOSTNAMES.has(hostname));
    });
}
//# sourceMappingURL=publishedAppUrl.js.map